export default __webpack_public_path__ + "static/media/bg-pattern-how-we-work-desktop.eb268c33.svg";